import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=60896046&scoped=true"
import script from "./OrderManage.vue?vue&type=script&lang=js"
export * from "./OrderManage.vue?vue&type=script&lang=js"
import style0 from "./OrderManage.vue?vue&type=style&index=0&id=60896046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60896046",
  null
  
)

export default component.exports